import { render, staticRenderFns } from "./RepeatableElementCard.vue?vue&type=template&id=8ecce62e&"
import script from "./RepeatableElementCard.vue?vue&type=script&lang=js&"
export * from "./RepeatableElementCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports